import { Box, Typography, Avatar, Grid, useTheme } from "@mui/material";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";

export default function ClassicIDCard({ data, school, colors, code, fontcolor }) {
    const items = Array.isArray(data) ? data : [];
    const theme = useTheme();
    const truncate = (text, max = 27) =>
        text?.length > max ? text.slice(0, max) + ".." : text;
    return (
        <Box id="emp-id-cards-root">
            <Grid container spacing={2}>
                {items?.map((emp) => (
                    <Box sx={{
                        width: 320,
                        height: 450,
                        bgcolor: "white",
                        borderRadius: 3,
                        overflow: "hidden",
                        boxShadow: 5,
                        display: "flex"
                    }} key={emp.id}>

                        {/* LEFT STRIP */}
                        <Box sx={{
                            width: '20%',
                            bgcolor: colors[emp.id] || theme.palette.primary.main,
                            color: fontcolor || "white",
                            writingMode: "vertical-rl",
                            textOrientation: "mixed",
                            display: "flex",
                            flexWrap: 'wrap',
                            alignContent: 'center',
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: 800,
                            letterSpacing: 2
                        }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.5 }}>
                                {school.schoolName}
                            </Typography>
                            <Typography variant="caption" sx={{ display: "block", lineHeight: 1.2 }}>
                                {[school.addressDTO.addressLine1, school.addressDTO.city, school.addressDTO.pincode, school.addressDTO.state].join(", ")}
                                | Tel: {school.contactPhone}
                            </Typography>
                        </Box>

                        {/* MAIN */}
                        <Box sx={{ flex: 1, p: 1, textAlign: "center" }}>

                            <img src={school?.logoUrl || null} height={80} alt="logo" />

                            <Box mt={0.5}>
                                <Avatar src={emp.photo || null}
                                    sx={{
                                        width: 110,
                                        height: 110,
                                        margin: "auto",
                                        border: `4px solid ${colors[emp.id] || theme.palette.primary.main}`
                                    }} />
                            </Box>

                            <Typography fontWeight={900} mt={2}>
                                {[emp.firstName, emp.lastName].join(" ")}
                            </Typography>

                            <Typography
                                sx={{
                                    display: "inline-block",
                                    bgcolor: colors[emp.id] || theme.palette.primary.main,
                                    color: fontcolor || "white",
                                    px: 2,
                                    borderRadius: 1,
                                    fontSize: 12
                                }}>
                                {emp.experience < 1 ? "" : "Senior"}  {[emp.specialization, "Teacher"].join(" ")}
                            </Typography>

                            <Box mt={1} fontSize={10} textAlign="left">
                                <Typography variant="subtitle2"><b>ID</b> : {emp.employeeCode}</Typography>
                                {/* <Typography variant="subtitle2"><b>Email</b> : {truncate(emp.email)}</Typography> */}
                                <Typography variant="subtitle2"><b>Phone</b> : {emp.phone}</Typography>
                                {/* <Typography variant="subtitle2"><b>Blood</b> : {emp.blood}</Typography> */}
                                <Typography variant="subtitle2"><b>Address</b> : {emp?.addressDTO?.addressLine1}</Typography>
                            </Box>


                            <Box mt={1} fontSize={10} >
                                {code === 'QRCode' ? (
                                    <QRCode value={[emp.id, emp.employeeCode].join("#")} size={70} />
                                ) : code === 'Barcode' ? (
                                    <Barcode width={1} height={60} value={[emp.id, emp.employeeCode].join("#")}
                                    // format="CODE128"
                                    />
                                ) : null}
                            </Box>
                        </Box>

                    </Box>
                ))}
            </Grid>
        </Box>
    )
}
